import { render, staticRenderFns } from "./VButton.vue?vue&type=template&id=53913e40&scoped=true&"
import script from "./VButton.vue?vue&type=script&lang=js&"
export * from "./VButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53913e40",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/var/www/web1/htdocs/kundenlogin/components/Spinner.vue').default})
